
<section class="breadcrumb-banner">
	<div class="container">
		<div class="row">
			<div class="col-md-12 col-lg-12">
				<div class="breadcrumb-text">
					<h1>Classical Conclave</h1>
				</div>
			</div>
		</div>
	</div>
    <div class="breadcrumb-bottom-img">
        <img
            src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/identity/white-group-identity.png"  alt="GHRSCF"/>
    </div>
</section>
<section class="section section-sm online-rahul-joshi section-banner-bg-1">
    <div class="container">
        <div class="sec-title text-center">
            <h2> Music Clinic <br><span > Music For Health &Happiness</span></h2>
            <p>(Meaningful Bollywood songs, Positive affirmations, transforming stories, Sing along, Spiritual humour)
            </p>
            <p>By</p>
            <p>Dr. Rahul Joshi (Homeopath, Singer and Motivator)</p>
        </div>
        <div class="row mt-5">
            <div class="col-lg-8">
                <div class=" text-justify">
                    <h2 class="head-lea">DR. RAHUL JOSHI <span class="small-sm">14 JUNE 2020</span></h2>
                    <p>Dr. Rahul Joshi is a MA in classical music and is learning music since last 19 years. He has
                        learnt from Kalyanji bhai and O P Nayyar as well.</p>
                    <p>Dr. Rahul is widely known as a versatile singer and sings songs of almost all singers from Saigal
                        to Sonu! He has an amazing range of 3 Octaves and singing is his passion.</p>
                    <p>He is a leading Homeopath attached to the most prestigious institutes of Mumbai. Dr. Joshi is the
                        Honorary Homeopath to the Governor of Maharashtra and Mumbai Police.</p>
                    <p>Rahul has been privileged to share the stage recently with the likes of Suresh Wadkar, Sadhana
                        Sargam.</p>
                </div>
            </div>

            <div class="col-md-4">
                <div class="image-effect-3">
                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/online-invitation-rahuljoshi1.webp"
                        alt="GHRSCF">
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-lg-8">

                <h6 class="fw-bold">LET’S MEET THEN.</h6>
                <h6 class="fw-bold">G.H. RAISONI SPORTS & CULTURAL FOUNDATION ORGANIZES - ONLINE SESSION</h6>
                <h6 class="fw-bold">MUSIC CLINIC MUSIC FOR HEALTH & HAPPINESS (MEANINGFUL BOLLYWOOD SONGS, POSITIVE
                    AFFIRMATIONS, TRANSFORMING STORIES,</h6>
                <p>Performer: Dr. Rahul Joshi (Homeopath, singer and motivator)</p>
                <p>Date : Sunday, 14<sup>th</sup> June 2020</p>
                <p>Time : 7:00 Pm</p>
                <p>Venue : Your Home at your Mobile</p>

                <h6 class="fw-bold">NOTE - LOGIN TO YOUR FACEBOOK ACCOUNTS 10 MINS BEFORE THE SESSION</h6>
                <p>Link: <a href="https://facebook.com/sgrkf/live" target="_blank">https://facebook.com/sgrkf/live</a>
                </p>

            </div>
            <div class="col-md-4">
                <div class="image-effect-3">
                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/online-invitation-rahuljoshi1.web"
                        alt="GHRSCF">
                </div>
            </div>
        </div>

        <div class="border-line-sm"></div>

        <div class="row row-cols-1 row-cols-md-3">
            <div class="col">
                <div class="row">
                    <div class="col-md-7">
                        <div class="widget_title inner-title">
                            <h4 class="fw-bold">You can also visit</h4>
                        </div>
                    </div>
                    <div class="col-md-5 text-end">
                        <a href="media#media_classical" target="_blank" class="btn button--effect-1"><span>
                                View More</span> <i class="fa fa-caret-square-o-right" aria-hidden="true"></i>
                        </a>
                    </div>
                </div>
                <iframe width="100%" height="230"
                    src="https://www.facebook.com/plugins/video.php?height=476&href=https%3A%2F%2Fwww.facebook.com%2Fsgrkf%2Fvideos%2F721387175316198%2F&show_text=false&width=267&t=0"
                    allowfullscreen></iframe>
            </div>
        </div>
    </div>
</section>
